import React from 'react';

export const VisaLogo = () => {
  return (
    <svg
      width="38"
      height="24"
      viewBox="0 0 38 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#1434CB"
        d="m14.428 6.217-4.975 11.87H6.207L3.76 8.614c-.149-.583-.278-.797-.73-1.043-.738-.4-1.957-.776-3.029-1.01l.073-.344h5.225c.666 0 1.264.443 1.415 1.21l1.293 6.869 3.196-8.08h3.226Zm12.718 7.994c.013-3.133-4.332-3.305-4.302-4.705.009-.425.415-.878 1.302-.994.44-.057 1.652-.101 3.027.531l.54-2.517A8.25 8.25 0 0 0 24.84 6c-3.035 0-5.17 1.613-5.189 3.924-.02 1.709 1.525 2.662 2.688 3.23 1.197.581 1.599.955 1.594 1.475-.008.796-.954 1.148-1.838 1.162-1.544.023-2.44-.418-3.153-.75l-.557 2.6c.718.33 2.042.617 3.415.631 3.226 0 5.336-1.593 5.346-4.06Zm8.014 3.876H38l-2.479-11.87H32.9c-.59 0-1.087.343-1.307.87l-4.607 11h3.224l.64-1.773h3.94l.37 1.773Zm-3.426-4.206 1.616-4.457.93 4.457h-2.546ZM18.815 6.217l-2.539 11.87h-3.07l2.54-11.87h3.07Z"
      />
    </svg>
  );
};
